/* eslint-disable max-len */
export const BlogIndexMobile = "/mobile/blog";
export const BlogPostMobile = { url: "/mobile/blog/%7Bslug%7D/%7Bid%7D", type: undefined as { slug: string | number; id: string | number; } };
export const BlogApi = { url: "/api/blog/%7Baction%7D", type: undefined as { action: string | number; } };
